module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lesson-banner"
  }, [_c('div', {
    staticClass: "lesson-title"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), (_vm.signNum > 0) ? _c('p', [_vm._v("还剩" + _vm._s(_vm.signNum) + "个名额")]) : _c('p', [_vm._v("名额已满")])]), _vm._v(" "), _c('div', {
    staticClass: "p-images l-images"
  }, [_c('swiper', {
    attrs: {
      "config": _vm.swiper,
      "paginateCls": ("" + (_vm.swiper.paginateCls))
    }
  }, [_vm._l((_vm.product.videos), function(video, index) {
    return (_vm.product.videos.length) ? _c('div', {
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "product-video",
      class: 'p' + index
    }, [_c('beast-video', {
      attrs: {
        "wrap": 'p' + index,
        "isHeight": true,
        "poster": video.thumbnailUrl,
        "autoplay": false,
        "source": video.url,
        "controls": true
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.product.images), function(item) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [_c('beast-image', {
      attrs: {
        "src": item
      }
    })], 1)
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b762b296"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/lesson/product-banner.vue
// module id = 1048
// module chunks = 2